import * as Cesium from '@cesiumgs/cesium-analytics'
import * as turf from '@turf/turf'
import type {
  ScreenSpaceEventHandler,
  Viewer,
} from '@cesiumgs/cesium-analytics'
import type Cartesian3 from '@cesiumgs/cesium-analytics/Source/Core/Cartesian3'

class CustomVolumeMeasure {
  cesiumview: any = null
  lineEntity = new Cesium.Entity()
  _drawLayer: any = null
  pickHandler: ScreenSpaceEventHandler | null = null
  _handlers3: any = null
  _handlers: any = null
  _handlers1: any = null
  _handlers2: any = null

  ispickclear = false
  isOpenDisSpace = false
  isOpenDis = false
  isOpenAre = false
  isOpenSanjiao = false
  pickBillboard: any = null
  mathList = null
  cartesianData = null

  leftMouse: any = null
  rightMouse: any = null
  flyTopoint = null
  flyToposition: any = null
  flyToorientation: any = null

  constructor(vivewr: Viewer) {
    this.cesiumview = vivewr
    this._drawLayer = new Cesium.CustomDataSource('measureLayer')
    this.cesiumview && this.cesiumview.dataSources.add(this._drawLayer)

    this.pickHandler = new Cesium.ScreenSpaceEventHandler(
      this.cesiumview.scene.canvas,
    )

    // this.pickHandler.setInputAction((movement: any) => {
    //   const pick = this.cesiumview && this.cesiumview.scene.pick(movement.position)
    //   const entities = this._drawLayer && this._drawLayer.entities._entities._array

    //   if (
    //     pick
    //     && pick.primitive
    //     && pick.primitive instanceof Cesium.Billboard
    //   ) {
    //     if (this._handlers2) {
    //       this._handlers2.removeInputAction(
    //         Cesium.ScreenSpaceEventType.RIGHT_CLICK,
    //       )
    //     }
    //     const name = pick.id._name
    //     for (let i = 0; i < entities.length; i++) {
    //       if (entities[i]._name && entities[i]._name === name) {
    //         this._drawLayer.entities.remove(entities[i])
    //         i--
    //       }
    //     }
    //     this.ispickclear = true
    //   }
    //   else {
    //     this.ispickclear = false
    //   }
    // }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    // this.pickHandler.setInputAction((movement: any) => {
    //   const pick = this.cesiumview.scene.pick(movement.endPosition)
    //   if (
    //     pick
    //     && pick.primitive
    //     && pick.primitive instanceof Cesium.Billboard
    //     && pick.id.billboard
    //   ) {
    //     pick.id.billboard.image.setValue('./measure/closefill.png')
    //     this.pickBillboard = pick.id.billboard.image
    //     this.cesiumview._container.style.cursor = 'pointer'
    //   }
    //   else {
    //     if (this.pickBillboard) {
    //       this.pickBillboard.setValue('./measure/close.png')
    //       this.pickBillboard = null
    //       this.cesiumview._container.style.cursor = 'default'
    //     }
    //   }
    // }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }

  /**
   * sanjiao measure
   * @param {*} options
   */
  getPositionDistanceHeight(positions: any) {
    let distance = 0
    for (let i = 0; i < positions.length - 1; i++) {
      const point1cartographic = this.transformWGS84ToCartographic(positions[i])
      const point2cartographic = this.transformWGS84ToCartographic(
        positions[i + 1],
      )
      const geodesic = new Cesium.EllipsoidGeodesic()
      geodesic.setEndPoints(point1cartographic, point2cartographic)
      let s = geodesic.surfaceDistance
      s = Math.sqrt(
        s ** 2
        + (point2cartographic.height - point1cartographic.height) ** 2,
      )
      distance = distance + s
    }
    return distance.toFixed(3)
  }

  destroy() {
    this._drawLayer?.entities.removeAll()
    if (this._handlers) {
      this._handlers.destroy()
      this._handlers = null
    }
    if (this._handlers1) {
      this._handlers1.destroy()
      this._handlers1 = null
    }
    if (this._handlers2) {
      this._handlers2.destroy()
      this._handlers2 = null
    }
    if (this._handlers3) {
      this._handlers3.destroy()
      this._handlers3 = null
    }
    if (this.leftMouse) {
      this.leftMouse.destroy()
      this.leftMouse = null
      if (this.flyTopoint)
        this.cesiumview.entities.remove(this.flyTopoint)
      this.cesiumview.trackedEntity = null
      this.cesiumview.camera.lookAtTransform(Cesium.Matrix4.IDENTITY)
      this.cesiumview.scene.screenSpaceCameraController.enableTranslate = true
      this.cesiumview.scene.screenSpaceCameraController.enableZoom = true
      this.cesiumview.camera.setView({
        destination: Cesium.Cartesian3.fromDegrees(
          this.flyToposition.lng,
          this.flyToposition.lat,
          this.flyToposition.alt,
        ),
        orientation: {
          heading: this.flyToorientation.heading,
          pitch: this.flyToorientation.pitch,
          roll: this.flyToorientation.roll,
        },
      })
    }
    if (this.rightMouse) {
      this.rightMouse.destroy()
      this.rightMouse = null
    }
    this.isOpenDis = false
    this.isOpenDisSpace = false
    this.isOpenAre = false
    this.isOpenSanjiao = false
  }

  drawTrianglesMeasureGraphicsVolume(options: any = {}) {
    options.style = options.style || {
      width: 3,
      material: Cesium.Color.YELLOW.withAlpha(0.5),
    }
    if (this.cesiumview && options) {
      let _trianglesEntity = null
      let _tempLineEntity = null
      let _tempLineEntity2 = null
      let _positions: any = []
      let _tempPoints: any = []
      let _tempPoints2: any = []
      this.destroy()
      this._handlers2 = new Cesium.ScreenSpaceEventHandler(
        this.cesiumview.scene.canvas,
      )
      this.isOpenSanjiao = true
      if (this._handlers1) {
        this._handlers1.destroy()
        this._handlers1 = null
      }
      if (this._handlers) {
        this._handlers.destroy()
        this._handlers = null
      }
      if (this._handlers3) {
        this._handlers3.destroy()
        this._handlers3 = null
      }
      let layername = ''

      // height
      const _getHeading = (startPosition: Cartesian3, endPosition: Cartesian3): number | null => {
        if (!startPosition && !endPosition)
          return 0
        if (Cesium.Cartesian3.equals(startPosition, endPosition))
          return 0
        const cartographic = Cesium.Cartographic.fromCartesian(startPosition)
        const cartographic2 = Cesium.Cartographic.fromCartesian(endPosition)
        return Number((cartographic2.height - cartographic.height).toFixed(2))
      }

      // pian yi point
      const _computesHorizontalLine = (positions: any) => {
        const cartographic = Cesium.Cartographic.fromCartesian(positions[0])
        const cartographic2 = Cesium.Cartographic.fromCartesian(positions[1])
        return Cesium.Cartesian3.fromDegrees(
          Cesium.Math.toDegrees(cartographic.longitude),
          Cesium.Math.toDegrees(cartographic.latitude),
          cartographic2.height,
        )
      }

      // left
      this._handlers2.setInputAction((movement: any) => {
        const position = this.getCatesian3FromPX(movement.position)
        if (!position && !position.z)
          return false
        if (this.ispickclear) {
          return false
        }
        if (_positions.length === 0) {
          layername = `m${new Date().getTime()}`
          _positions.push(position.clone())
          _positions.push(position.clone())
          _tempPoints.push(position.clone())
          _tempPoints.push(position.clone())
          // mouse
          this._handlers2.setInputAction((movement: any) => {
            const position = this.getCatesian3FromPX(movement.endPosition)
            if (position && _positions.length > 0) {
              // line
              _positions.pop()
              _positions.push(position.clone())
              const horizontalPosition = _computesHorizontalLine(_positions)
              // height
              _tempPoints.pop()
              _tempPoints.push(horizontalPosition.clone())
              // shuiping line
              _tempPoints2.pop()
              _tempPoints2.pop()
              _tempPoints2.push(position.clone())
              _tempPoints2.push(horizontalPosition.clone())
            }
          }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

      // right
      this._handlers2.setInputAction((movement: any) => {
        this._handlers2.removeInputAction(
          Cesium.ScreenSpaceEventType.MOUSE_MOVE,
        )
        if (this.isOpenSanjiao) {
          this.isOpenSanjiao = false
          this._handlers2.removeInputAction(
            Cesium.ScreenSpaceEventType.LEFT_CLICK,
          )
        }
        if (typeof options.callback === 'function') {
          options.callback(
            Math.abs(Number(Number(_getHeading(_tempPoints[0], _tempPoints[1])).toFixed(2))),
          )
        }
        _trianglesEntity = new Cesium.Entity({
          name: layername,
          polyline: {
            positions: _positions,
            ...options.style,
          },
          position: _positions[0],
          point: {
            pixelSize: 5,
            outlineColor: Cesium.Color.YELLOW,
            outlineWidth: 5,
          },
          // label: {
          //   text:
          //     `높이:${
          //     Math.abs(Number(Number(_getHeading(_tempPoints[0], _tempPoints[1])).toFixed(2)))
          //     } m\n`
          //     + `사선 거리 :${
          //     Number(
          //       this.getPositionDistanceHeight(
          //         this.transformCartesianArrayToWGS84Array(_positions),
          //       ),
          //     ).toFixed(2)
          //     } m\n`
          //     + `수평 거리:${
          //     Number(
          //       this.getPositionDistanceHeight(
          //         this.transformCartesianArrayToWGS84Array(_tempPoints2),
          //       ),
          //     ).toFixed(2)
          //     } m`,
          //   show: true,
          //   showBackground: true,
          //   font: '14px monospace',
          //   horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
          //   verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          //   pixelOffset: new Cesium.Cartesian2(50, -100), // left top
          // },
          // billboard: {
          //   image: './measure/close.png',
          //   show: true, // default
          //   pixelOffset: new Cesium.Cartesian2(35, -95), // default: (0, 0)
          //   eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          //   horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          //   verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          //   alignedAxis: Cesium.Cartesian3.ZERO, // default
          //   width: 30, // default: undefined
          //   height: 30, // default: undefined
          // },
        })

        // height
        _tempLineEntity = new Cesium.Entity({
          name: layername,
          polyline: {
            positions: _tempPoints,
            ...options.style,
          },
          position: _tempPoints2[1],
          point: {
            pixelSize: 5,
            outlineColor: Cesium.Color.YELLOW,
            outlineWidth: 5,
          },
        })
        _tempLineEntity2 = new Cesium.Entity({
          name: layername,
          polyline: {
            positions: _tempPoints2,
            ...options.style,
          },
          position: _positions[1],
          point: {
            pixelSize: 5,
            outlineColor: Cesium.Color.YELLOW,
            outlineWidth: 5,
          },
        })

        this._drawLayer.entities.add(_tempLineEntity2)
        this._drawLayer.entities.add(_tempLineEntity)
        this._drawLayer.entities.add(_trianglesEntity)
        _positions = []
        _tempPoints = []
        _tempPoints2 = []
      }, Cesium.ScreenSpaceEventType.RIGHT_CLICK)
      // create entity

      // line
      _trianglesEntity = new Cesium.Entity({
        name: layername,
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            return _positions
          }, false),
          ...options.style,
        },
        position: new Cesium.CallbackProperty(() => {
          return _positions[0]
        }, false) as any,
        point: {
          pixelSize: 5,
          outlineColor: Cesium.Color.YELLOW,
          outlineWidth: 5,
        },
        // label: {
        //   text: new Cesium.CallbackProperty(() => {
        //     return (
        //       `높이:${
        //       Math.abs(Number(Number(_getHeading(_tempPoints[0], _tempPoints[1])).toFixed(2)))
        //       } m\n`
        //       + `사선 거리 :${
        //       Number(
        //         this.getPositionDistanceHeight(
        //           this.transformCartesianArrayToWGS84Array(_positions),
        //         ),
        //       ).toFixed(2)
        //       } m\n`
        //       + `수평 거리:${
        //       Number(
        //         this.getPositionDistanceHeight(
        //           this.transformCartesianArrayToWGS84Array(_tempPoints2),
        //         ),
        //       ).toFixed(2)
        //       } m`
        //     )
        //   }, false),
        //   show: true,
        //   showBackground: true,
        //   font: '14px monospace',
        //   horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
        //   verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        //   pixelOffset: new Cesium.Cartesian2(50, -100), // left top
        // },
        // billboard: {
        //   image: './measure/close.png',
        //   show: true, // default
        //   pixelOffset: new Cesium.Cartesian2(35, -95), // default: (0, 0)
        //   eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
        //   horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
        //   verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
        //   alignedAxis: Cesium.Cartesian3.ZERO, // default
        //   width: 30, // default: undefined
        //   height: 30, // default: undefined
        // },
      })
      // height
      _tempLineEntity = new Cesium.Entity({
        name: layername,
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            return _tempPoints
          }, false),
          ...options.style,
        },
        position: new Cesium.CallbackProperty(() => {
          return _tempPoints2[1]
        }, false) as any,
        point: {
          pixelSize: 5,
          outlineColor: Cesium.Color.YELLOW,
          outlineWidth: 5,
        },
      })
      _tempLineEntity2 = new Cesium.Entity({
        name: layername,
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            return _tempPoints2
          }, false),
          ...options.style,
        },
        position: new Cesium.CallbackProperty(() => {
          return _positions[1]
        }, false) as any,
        point: {
          pixelSize: 5,
          outlineColor: Cesium.Color.YELLOW,
          outlineWidth: 5,
        },
      })

      this._drawLayer.entities.add(_tempLineEntity2)
      this._drawLayer.entities.add(_tempLineEntity)
      this._drawLayer.entities.add(_trianglesEntity)
    }
  }

  /**
   * Calculates the area of a set of coordinates that make up a polygon
   * @param {*} positions
   */
  getPositionsArea(positions: any) {
    const lnglatArr: any = []
    positions.forEach((item: any) => {
      lnglatArr.push([item.lng, item.lat])
    })
    const polygon = turf.polygon([lnglatArr])

    const area = turf.area(polygon)
    return area
  }

  /**
   * Gets the distance at the 84 coordinate
   * @param {*} positions
   */
  getPositionDistance1(positions: any) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    let distance = 0
    for (let i = 0; i < positions.length - 1; i++) {
      const point1cartographic = this.transformWGS84ToCartographic(positions[i])
      const point2cartographic = this.transformWGS84ToCartographic(
        positions[i + 1],
      )
      const geodesic = new Cesium.EllipsoidGeodesic()
      geodesic.setEndPoints(point1cartographic, point2cartographic)
      const s = geodesic.surfaceDistance
      const cartoPts = [point1cartographic]
      for (let jj = 1000; jj < s; jj += 1000) {
        const cartoPt = geodesic.interpolateUsingSurfaceDistance(jj)
        cartoPts.push(cartoPt)
      }
      cartoPts.push(point2cartographic)
      const promise = Cesium.sampleTerrain(
        this.cesiumview.terrainProvider,
        8,
        cartoPts,
      )
      promise.then((updatedPositions) => {
        let data = 0
        for (let jj = 0; jj < updatedPositions.length - 1; jj++) {
          const geoD = new Cesium.EllipsoidGeodesic()
          geoD.setEndPoints(updatedPositions[jj], updatedPositions[jj + 1])
          let innerS = geoD.surfaceDistance
          innerS = Math.sqrt(
            innerS ** 2
              + (updatedPositions[jj + 1].height - updatedPositions[jj].height) ** 2,
          )
          data += innerS
        }
        externalFunction(data)
      })
    }

    function externalFunction(result: any) {
      that.mathList = result
    }

    distance = distance + (that.mathList || 0)
    return distance.toFixed(3)
  }

  async getPositionDistance(positions: any) {
    let distance = 0
    for (let i = 0; i < positions.length - 1; i++) {
      const point1cartographic = positions[i]
      const point2cartographic = positions[i + 1]
      const data = await this.getTerrainDistance(
        point1cartographic,
        point2cartographic,
      )
      distance = distance + Number(data) + 60
    }
    return distance.toFixed(3)
  }

  getTerrainDistance(start: any, end: any) {
    return new Promise((resolve) => {
      const lerpArray = []
      const splitNum = Number.parseInt(Cesium.Cartesian3.distance(start, end) as any)
      const startCartographic = Cesium.Cartographic.fromCartesian(start)
      const startDegrees = [
        startCartographic.longitude,
        startCartographic.latitude,
      ]
      const endCartographic = Cesium.Cartographic.fromCartesian(end)
      const endDegrees = [endCartographic.longitude, endCartographic.latitude]
      lerpArray.push(new Cesium.Cartographic(startDegrees[0], startDegrees[1]))
      for (let i = 1; i <= splitNum - 1; i++) {
        const x = Cesium.Math.lerp(startDegrees[0], endDegrees[0], i / splitNum)
        const y = Cesium.Math.lerp(startDegrees[1], endDegrees[1], i / splitNum)
        lerpArray.push(new Cesium.Cartographic(x, y))
      }
      Cesium.sampleTerrainMostDetailed(
        this.cesiumview.terrainProvider,
        lerpArray,
      ).then((cartographicArr) => {
        this.getDetailedTerrainDistance(cartographicArr).then((distance) => {
          resolve(distance)
        })
      })
    })
  }

  getDetailedTerrainDistance(cartographicArr: any) {
    return new Promise((resolve) => {
      let terrainDistance = 0
      cartographicArr.forEach((currentCartographic: any, index: number) => {
        if (index === cartographicArr.length - 1) {
          return
        }
        const nextCartographic = cartographicArr[index + 1]
        const currentPosition = Cesium.Cartesian3.fromRadians(
          currentCartographic.longitude,
          currentCartographic.latitude,
          currentCartographic.height,
        )
        const nextPosition = Cesium.Cartesian3.fromRadians(
          nextCartographic.longitude,
          nextCartographic.latitude,
          nextCartographic.height,
        )
        terrainDistance += Cesium.Cartesian3.distance(
          currentPosition,
          nextPosition,
        )
      })
      resolve(terrainDistance)
    })
  }

  /***
   * Coordinate array conversion cartesian to 86
   *
   * @param {Array} cartesianArr Three dimensional position coordinate array
   *
   * @return {Array} {lng,lat,alt} Geographic coordinate array
   */
  transformCartesianArrayToWGS84Array(cartesianArr: any) {
    if (this.cesiumview) {
      return cartesianArr
        ? cartesianArr.map((item: any) => {
          return this.transformCartesianToWGS84(item)
        })
        : []
    }
  }

  /**
   * 84 coordinates in degrees of radians
   * @param {Object} position wgs84
   * @return {Object} Cartographic Arc coordinates
   *
   */
  transformWGS84ToCartographic(position: any) {
    return position
      ? Cesium.Cartographic.fromDegrees(
        position.lng || position.lon,
        position.lat,
        position.alt,
      )
      : Cesium.Cartographic.ZERO
  }

  /**
   * Pick up position points
   *
   * @param {Object} px screen coordinates
   *
   * @return {Object} Cartesian3 three-dimensional coordinate
   */
  getCatesian3FromPX(px: any) {
    if (this.cesiumview && px) {
      const picks = this.cesiumview.scene.drillPick(px)
      let cartesian = null
      let isOn3dtiles = false
      let isOnTerrain = false
      // drillPick
      for (const i in picks) {
        const pick = picks[i]

        if (
          (pick && pick.primitive instanceof Cesium.Cesium3DTileFeature)
          || (pick && pick.primitive instanceof Cesium.Cesium3DTileset)
          || (pick && pick.primitive instanceof Cesium.Model)
        ) {
          // Pick on model
          isOn3dtiles = true
        }
        // 3dtilset
        if (isOn3dtiles) {
          this.cesiumview.scene.pick(px) // pick
          cartesian = this.cesiumview.scene.pickPosition(px)
          if (cartesian) {
            const cartographic = Cesium.Cartographic.fromCartesian(cartesian)
            if (cartographic.height < 0)
              cartographic.height = 0
            const lon = Cesium.Math.toDegrees(cartographic.longitude)
            const lat = Cesium.Math.toDegrees(cartographic.latitude)
            const height = cartographic.height
            cartesian = this.transformWGS84ToCartesian({
              lng: lon,
              lat,
              alt: height,
            })
          }
        }
      }
      // terrain
      const boolTerrain
        = this.cesiumview.terrainProvider
        instanceof Cesium.EllipsoidTerrainProvider
      // Terrain
      if (!isOn3dtiles && !boolTerrain) {
        const ray = this.cesiumview.scene.camera.getPickRay(px)
        if (!ray)
          return null
        cartesian = this.cesiumview.scene.globe.pick(
          ray,
          this.cesiumview.scene,
        )
        isOnTerrain = true
      }
      // global
      if (!isOn3dtiles && !isOnTerrain && boolTerrain) {
        cartesian = this.cesiumview.scene.camera.pickEllipsoid(
          px,
          this.cesiumview.scene.globe.ellipsoid,
        )
      }
      if (cartesian) {
        const position = this.transformCartesianToWGS84(cartesian)
        if (position && position.alt < 0) {
          cartesian = this.transformWGS84ToCartesian(position, 0.1)
        }
        return cartesian
      }
      return false
    }
  }

  /***
   * The coordinate transformation is 84 to Cartesian
   *
   * @param {Object} {lng,lat,alt} geographical coordinates
   *
   * @return {Object} Cartesian3 Three dimensional position coordinates
   */
  transformWGS84ToCartesian(position: any, alt?: any) {
    if (this.cesiumview) {
      return position
        ? Cesium.Cartesian3.fromDegrees(
          position.lng || position.lon,
          position.lat,
          (position.alt = alt || position.alt),
          Cesium.Ellipsoid.WGS84,
        )
        : Cesium.Cartesian3.ZERO
    }
  }

  /***
   * Coordinates convert Descartes to 84
   *
   * @param {Object} Cartesian3 Three dimensional position coordinates
   *
   * @return {Object} {lng,lat,alt} geographical coordinates
   */
  transformCartesianToWGS84(cartesian: any) {
    if (this.cesiumview && cartesian) {
      const ellipsoid = Cesium.Ellipsoid.WGS84
      const cartographic = ellipsoid.cartesianToCartographic(cartesian)
      return {
        lng: Cesium.Math.toDegrees(cartographic.longitude),
        lat: Cesium.Math.toDegrees(cartographic.latitude),
        alt: cartographic.height,
      }
    }
  }

  getcameraPosInfo() {
    const head = this.cesiumview.scene.camera.heading
    const pitch = this.cesiumview.scene.camera.pitch
    const roll = this.cesiumview.scene.camera.roll

    const position = this.cesiumview.scene.camera.positionCartographic // with longitude and latitude expressed in radians and height in meters.

    const longitude = Cesium.Math.toDegrees(position.longitude).toFixed(6)
    const latitude = Cesium.Math.toDegrees(position.latitude).toFixed(6)
    const height = position.height
    return Cesium.Cartesian3.fromDegrees(
      Number(longitude),
      Number(latitude),
      height,
    )
  }

  getHeading(pointA: Cesium.Cartesian3, pointB: Cesium.Cartesian3): number {
    const transform = Cesium.Transforms.eastNorthUpToFixedFrame(pointA)

    const positionvector = Cesium.Cartesian3.subtract(
      pointB,
      pointA,
      new Cesium.Cartesian3(),
    )

    const vector = Cesium.Matrix4.multiplyByPointAsVector(
      Cesium.Matrix4.inverse(transform, new Cesium.Matrix4()),
      positionvector,
      new Cesium.Cartesian3(),
    )

    const direction = Cesium.Cartesian3.normalize(
      vector,
      new Cesium.Cartesian3(),
    )
    // heading
    const heading
      = Math.atan2(direction.y, direction.x) - Cesium.Math.PI_OVER_TWO
    return (
      (Cesium.Math.TWO_PI - Cesium.Math.zeroToTwoPi(heading)) * (180 / Math.PI)
    )
  }
}

export default CustomVolumeMeasure
